import {
  DialogContent,
  Dialog,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import "../i18n/config";
import { GroupMemberInfo } from "../types/gigya";
import { useTranslation } from "react-i18next";

type ModalNicknameProps = {
  member: GroupMemberInfo | undefined;
  isOpen: boolean;
  close: () => void;
  deleteMember: (memberToDel: GroupMemberInfo | undefined) => void;
  groupId: string;
};

export const ModalRemoveMember = (props: ModalNicknameProps) => {
  const { member, isOpen, close, deleteMember } = props;
  const { t } = useTranslation();

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <>
      {member && (
        <Dialog
          PaperProps={{ style: { height: "400px" } }}
          open={isOpen}
          onClose={close}
        >
          <DialogTitle>
            <Typography>
              {t(
                "members.Are you sure you want to delete this member from “College blvd Animal Hospital”?",
              )}
            </Typography>
          </DialogTitle>
          <DialogContent style={{ paddingTop: "4px" }}>
            <Typography
              key={1}
            >{`${t("exported.Name")}: ${member.profile.lastName}, ${member.profile.firstName}`}</Typography>
            <Typography
              key={1}
            >{`${t("exported.Role")}: ${t(`exported.${capitalizeFirstLetter(member.relationshipData.role)}`)}`}</Typography>
            <Typography
              key={1}
            >{`${t("exported.Email")}: ${member.profile.email}`}</Typography>
            <Typography key={1}>{t("members.deleteMemberText1")}</Typography>
            <Typography key={1}>{t("members.deleteMemberText2")}</Typography>
          </DialogContent>
          <DialogActions style={{ padding: "0 24px" }}>
            <Button key={0} variant="text" onClick={close}>
              {t("exported.Cancel")}
            </Button>
            <Button
              key={0}
              variant="text"
              onClick={() => {
                deleteMember(member);
              }}
            >
              {t("members.Delete")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default ModalRemoveMember;
